import MUIDataTable from "mui-datatables";

import { useTranslation } from "react-i18next";
import { getColumns, getOptions } from "./config";

const StatsList = ({ data }) => {
	const { t } = useTranslation();

	const columns = getColumns(t);
	const options = getOptions(t);

	return (
		<MUIDataTable
			className="mui-data-table center-all-cells statistics-table"
			data={data}
			columns={columns}
			options={options}
		/>
	);
};

export default StatsList;
